<template>
  <div :class="['flex items-center w-full relative', { error: validation?.[fcProp]?.$invalid }, containerClass]">
    <UiIcon icon="search" class="absolute left-2 top-3" size="24" />
    <input
      v-model.trim="model"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :disabled="(isDisabled || disabled)"
      :class="['ui-input peer', {
        'px-10 py-1': size === 'small',
        'px-10 py-3': !size || size === 'medium',
        'px-10 py-5': size === 'large',
        'border-l-0 border-t-0 border-r-0 border-b border-neutral-400/50': simple
      }]"
      v-bind="$attrs"
    />
    <button v-if="model" class="absolute right-2 top-3 bg-transparent border-none p-0" @click="model = ''">
      <UiIcon
        icon="x"
        size="20"
      />
    </button>
  </div>
</template>

<script setup lang="ts">
import { inject } from 'vue'

import UiIcon from './icon.vue'

defineOptions({
  inheritAttrs: false
})

defineProps<{
  placeholder?: string
  prefix?: string
  suffix?: string
  type?: string
  textTransform?: string
  disabled?: boolean
  maxlength?: number | string
  simple?: boolean
  rows?: number | string
  error?: any
  size?: 'small' | 'medium' | 'large'
  containerClass?: string
}>()

const model = defineModel<string | number>()

const isDisabled = inject('form-disabled', false)

const validation = inject('validation', {})
const fcProp = inject('fc-prop', '')
</script>

<style lang="scss">
.ui-input {
  @apply box-border rounded-md border border-neutral-400/50 bg-[#fdfdfd] text-sm leading-5 text-[#212121] outline-none transition-all placeholder:text-[#bbb] focus:border-[--c-primary-600] disabled:text-[#79767A] dark:border-[#2C2C2C] dark:bg-[#2C2C2C] dark:text-[#FDFDFD] dark:placeholder:text-[#D2D2D2] dark:focus:border-[--c-primary-600] dark:disabled:bg-[#414141];

  &:hover {
    @apply bg-[#f8f6fb] dark:bg-[#343434];
  }

  &:focus {
    @apply bg-[#f6f2f9] dark:bg-[#383838];
  }

  &:disabled {
    @apply bg-[#e6e1e6] dark:bg-[#414141];
  }
}

.ui-input-eye {
  @apply peer-focus:text-primary;
}

.ui-suffix-icon {
  @apply absolute top-0 right-0 px-2 h-full flex items-center;
}

.error > {
  .ui-input {
    @apply border-[#FF4980] bg-[#fcf2f6] dark:bg-[#383838];
  }

  .ui-input-eye {
    @apply text-[#FF4980]
  }
}

.error {
  .ui-input  {
    @apply border-red-400 bg-red-50 dark:bg-transparent;
  }
}

.success {
  .ui-input  {
    @apply border-emerald-300 bg-emerald-50 dark:bg-transparent;
  }
}
</style>
